import React from 'react';
import coinIcon from '../../../../../assets/svg/driver.svg';

const NoDrivers = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={coinIcon} alt="" height={60} width={60} />
      <div>با شرایط موجود راننده ای یافت نشد.</div>
    </div>
  );
};

export default React.memo(NoDrivers);

